


import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";

// const BASE_URL = ` https://backend.maamaas.com/food/api/aboutus/${vendorId}`;

const Aboutmaamaas = () => {
  const [aboutData, setAboutData] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const vendorId = localStorage.getItem("vendorId"); // ensure this is set
        const token = localStorage.getItem("authToken"); // ✅ get stored token

        if (!vendorId) {
          console.warn("Missing vendorId");
          return;
        }

        const res = await axios.get(
          ` https://backend.maamaas.com/food/api/vendor/aboutus/get/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ send token in headers
            },
          }
        );

        if (res.data) {
          setAboutData(res.data);
        }
      } catch (err) {
        console.error("❌ Failed to fetch about data:", err);
      }
    };

    fetchAboutData();
  }, []);




  return (
    <Container fluid className="py-5" style={styles.container}>
      <style>
        {`
          @media (max-width: 768px) {
            .about-row {
              flex-direction: column !important;
            }
            .about-text {
              padding-left: 20px !important;
              padding-right: 20px !important;
              margin-top: 20px !important;
            }
            .about-img {
              max-height: 250px !important;
            }
          }

          @media (min-width: 769px) {
            .about-img {
              max-height: 400px !important;
            }
          }
        `}
      </style>

      <Row className="align-items-center about-row" style={styles.row}>
        {/* Text Column */}
        <Col
          md={6}
          className="about-text"
          style={{
            order: isMobile ? 2 : 1,
            padding: "0 20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h1 style={styles.heading}>ABOUT US</h1>
          {aboutData.aboutUs ? (
            <p style={styles.text}>{aboutData.aboutUs}</p>
          ) : (
            <p style={styles.text}>No content available at the moment.</p>
          )}
        </Col>

        {/* Image Column */}
        <Col
          md={6}
          className="text-center p-4"
          style={{ order: isMobile ? 1 : 2 }}
        >
          <img
            src={`data:image/jpeg;base64,${aboutData?.image?.replace(/\s/g, "")}`}
            alt="About Us"
            style={styles.image}
            className="about-img"
          />
        </Col>
      </Row>
    </Container>
  );
};

// --- Styles ---
const styles = {
  container: {
    padding: "40px 0px",
    // Add this line
    borderRadius: "12px",
    backgroundColor: "#fff",

  },
  row: {
    borderRadius: "10px",
    margin: "0 auto",
    maxWidth: "1100px",
    display: "flex",
    flexWrap: "wrap",
    // border: "2px solid #ee6521",
    padding: "20px",
    backgroundColor: 'rgb(177 93 198)',
  },
  heading: {
    color: "rgb(255 225 36)",
    fontWeight: "bold",
    fontSize: "32px",
    marginBottom: "20px",
    textAlign: "left",
    fontFamily: "revert"
  },
  image: {
    width: "100%",
    objectFit: "cover",
    borderRadius: "12px",
    height: "300px",
    maxHeight: "350px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
  },
  text: {
    fontSize: "16px",
    color: "#fff",
    lineHeight: "1.8",
    textAlign: "justify",
    whiteSpace: "pre-line",
    fontFamily: 'math'
  },
};

export default Aboutmaamaas;
